const normalizeVsGamesPlex = (games) => {
  const normalizedVsGames = {};
  const gamesIds = [];

  games.forEach((game) => {
    const { launchId: launchGameId } = game;

    const lobbyImage = game.image;

    normalizedVsGames[game.id] = {
      ...game,
      gameCode: game.id,
      launchGameId,
      hasDemoSupport: game.supportDemo,
      provider: game.providerId,
      categoryName: game.name,
      categoryId: game.id,
      isFrame: true,
      lobbyImage,
      gameId: game.id
    };

    gamesIds.push(game.id);
  });

  return {
    data: normalizedVsGames,
    ids: [...new Set(gamesIds)],
    isLoaded: true
  };
};

const normalizeVsCategoriesPlex = (categories) => {
  const normalizedCategories = categories.reduce(
    (acc, category) => {
      return {
        ...acc,
        data: {
          ...acc.data,
          [category.id]: {
            games: category.games.map((game) => game.id),
            id: category.id,
            nameTranslationKey: category.name
          }
        },
        ids: [...acc.ids, category.id]
      };
    },
    {
      data: {},
      ids: [],
      isLoaded: true
    }
  );

  return normalizedCategories;
};

const normalizeVsProvidersPlex = (providers) => {
  return providers.reduce(
    (acc, provider) => {
      return {
        ...acc,
        data: {
          ...acc.data,
          [provider.id]: {
            ...provider,
            categoryId: provider.id,
            categoryName: provider.name,
            providerId: provider.id,
            providerName: provider.name,
            providerLogo: provider.logo,
            providerColoredLogo: provider.logoColored,
            serviceId: provider.serviceId?.toString(),
            games: provider.games.map((game) => game.id)
          }
        },
        ids: [...acc.ids, provider.id]
      };
    },
    {
      data: {},
      ids: [],
      isLoaded: true
    }
  );
};

export const parseVsGamesPlex = ({
  categoriesData,
  providersData,
  feedName
}) => {
  const normalizedCategories = normalizeVsCategoriesPlex(categoriesData);
  const allGames = [];
  categoriesData.forEach((category) => allGames.push(...category.games));
  providersData.forEach((provider) =>
    allGames.push(
      ...provider.games.map((game) => ({
        ...game,
        providerId: provider.id,
        providerName: provider.name
      }))
    )
  );

  const normalizedGames = normalizeVsGamesPlex(allGames);

  return {
    feedName,
    categories: normalizedCategories,
    providers: normalizeVsProvidersPlex(providersData),
    games: normalizedGames
  };
};
